<template>
  <div class="settings">
    <div class="content">
      <div class="wrapper">
        <div class="main-wrap">

          <div class="settings-header">
            Source Documents
          </div>

          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="Vendor Invoices" name="vendorInvoices">
              <vendor-invoices ref="vendorInvoices"/>
            </el-tab-pane>
            <el-tab-pane label="Bank Statement" name="bankStatement">Bank Statement</el-tab-pane>
            <el-tab-pane label="Credit Card Statements" name="creditCardStatements">Credit Card Statements</el-tab-pane>
            <el-tab-pane label="Cash on Hand Statements" name="cashOnHandStatements">Cash on Hand Statements</el-tab-pane>
            <el-tab-pane label="Liquidation Summaries" name="liquidationSummaries">Liquidation Summaries</el-tab-pane>
            <el-tab-pane label="Sales Documents" name="salesDocuments">Sales Documents</el-tab-pane>
          </el-tabs>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VendorInvoices from '@/components/sourceDocuments/VendorInvoices'

  export default {
    name: 'SourceDocuments',
    components: {
      VendorInvoices
    },
    data() {
      return {
        activeName: 'vendorInvoices',
      }
    },
    mounted() {
      this.$refs['vendorInvoices'].openTab()
    },
    methods: {
      routerLink(page) {
        this.$router.push({name: page, query: { companyId: this.$route.query.companyId}} )
      },
      handleClick(tab, event) {
        this.$refs[tab.name].openTab()
      },
    }
  }
</script>

<style lang="scss" scoped>
.settings {
  background: #DfE8F0;
}

.content {
  display: flex;
  min-height: 100vh;
  padding-top: 50px;
  .wrapper{
    background: #fff;
    margin: 10px;
    width: 100%;
    display: flex;
    justify-content: center;
    .main-wrap {
      padding: 20px;
      width: 100%;
      // max-width: 1500px;
    }
    &.animation{
      margin-left: 260px;
      transition: margin-left 500ms ease-out, transform 500ms ease-out;
    }
  }
}
</style>
